<template>
  <b-form-group
    label="Slogan"
    label-for="slogan"
  >
    <validation-provider
      #default="{ errors }"
      name="Slogan"
      rules="required"
    >
      <b-form-input
        id="slogan"
        v-model="itemData.slogan"
        placeholder="Slogan"
      />
      <small class="text-danger">{{ errors[0] }}</small>
    </validation-provider>
  </b-form-group>
</template>

<script>
import { ValidationProvider } from 'vee-validate'
import { BFormGroup, BFormInput } from 'bootstrap-vue'

export default {
  name: 'SubTitleText',
  components: {
    BFormGroup,
    BFormInput,
    ValidationProvider,
  },
  computed: {
    itemData() {
      return this.$store.getters['sustainability/dataItem']
    },
  },
}
</script>
